import request from '../utils/http'
// const appid =  2000  // 2000-维应SPR

// 742 物流地址记录-列表
export function getLogisticsAddressList(data) {
    return request({
        url: "/service/view04/special_user_addr.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type':'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: "special_user_addrpage",
           ...data
        }  //接口参数
    })
}

// 743 物流地址记录-添加
export function addLogisticsAddress(data) {
    return request({
        url: "/service/view04/special_user_addr.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type':'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: "special_user_addradd",
          ...data
        }  //接口参数
    })
}

// 744 物流地址记录-修改
export function editLogisticsAddress(data) {
    return request({
        url: "/service/view04/special_user_addr.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type':'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: "special_user_addredit",
          ...data
        }  //接口参数
    })
}

// 745 物流地址记录-查看
export function getLogisticsAddressDetail(data) {
    return request({
        url: "/service/view04/special_user_addr.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type':'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: "special_user_addrview",
         ...data
        }  //接口参数
    })
}

// 750 物流地址记录-删除
export function delLogisticsAddress(data) {
    return request({
        url: "/service/view04/special_user_addr.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type':'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: "special_user_addrdel",
        ...data
        }  //接口参数
    })
}

// 746 特别用户自建仓库资源管理-列表
export function getSpecialUserResourceList(data) {
    return request({
        url: "/service/view04/special_user_Warehouse_Hand.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type':'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: "special_user_Warehousepage",
        ...data
        }  //接口参数
    })
}

// 747 特别用户自建仓库资源管理-添加
export function addSpecialUserResource(data) {
    return request({
        url: "/service/view04/special_user_Warehouse_Hand.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type':'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: "special_user_Warehouseadd",
       ...data
        }  //接口参数
    })
}

// 748 特别用户自建仓库资源管理-修改
export function editSpecialUserResource(data) {
    return request({
        url: "/service/view04/special_user_Warehouse_Hand.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type':'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: "special_user_Warehouseedit",
      ...data
        }  //接口参数
    })
}

// 749 特别用户自建仓库资源管理-查看
export function getSpecialUserResourceDetail(data) {
    return request({
        url: "/service/view04/special_user_Warehouse_Hand.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type':'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: "special_user_Warehouseview",
        ...data
        }  //接口参数
    })
}

// 751 特别用户自建仓库资源管理-删除
export function delSpecialUserResource(data) {
    return request({
        url: "/service/view04/special_user_Warehouse_Hand.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type':'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: "special_user_Warehousedel",
        ...data
        }  //接口参数
    })
}